export default () => {
  let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return isSafari && iOS;
}



// WEBPACK FOOTER //
// ./src/utils/isSafariIOS.js